import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';

export const Image = superstyled({
  tag: SharedAsset,
  name: 'ExpressionSection',
  slot: 'Image',
  styles: ({ theme }) => ({
    borderRadius: theme.shape.rounded.lg,
  }),
});
